import React from "react";
import {
  PersonalDetailsForm,
  CommunicationDetailsForm,
  ConfirmationForm
} from "src/types/FormTypes";
import {
  personalDetailsInitialValues,
  communicationDetailsInitialValues,
  confirmationDetailsInitialValues
} from "src/utils/registrationFormUtils";

export function useFormInitialValuesRef() {
  const initialPersonalDetailsRef = React.useRef<string>(JSON.stringify(personalDetailsInitialValues));
  const initialCommunicationDetailsRef = React.useRef<string>(JSON.stringify(communicationDetailsInitialValues));
  const initialConfirmationValuesRef = React.useRef<string>(JSON.stringify(confirmationDetailsInitialValues));

  function setInitialPersonalDetails(val: PersonalDetailsForm) {
    initialPersonalDetailsRef.current = JSON.stringify(val);
  }
  function setInitialCommunicationDetails(val: CommunicationDetailsForm) {
    initialCommunicationDetailsRef.current = JSON.stringify(val);
  }
  function setInitialConfirmationValues(val: ConfirmationForm) {
    initialConfirmationValuesRef.current = JSON.stringify(val);
  }
  function resetAll() {
    initialPersonalDetailsRef.current = JSON.stringify(personalDetailsInitialValues);
    initialCommunicationDetailsRef.current = JSON.stringify(communicationDetailsInitialValues);
    initialConfirmationValuesRef.current = JSON.stringify(confirmationDetailsInitialValues);
  }

  return {
    initialPersonalDetailsRef,
    initialCommunicationDetailsRef,
    initialConfirmationValuesRef,
    setInitialPersonalDetails,
    setInitialCommunicationDetails,
    setInitialConfirmationValues,
    resetAll
  };
}
